window.okeReviewsWidgetOnInit = function() {
  var reviewSummaryElements = document.querySelectorAll('.product__form .js-okeReviews-reviewsSummary');
  var reviewTabElement = document.querySelector('#product-reviews-tab');
  if (reviewTabElement && reviewSummaryElements.length) {
    reviewSummaryElements.forEach(function(reviewSummaryElement) {
      reviewSummaryElement.addEventListener('click', function() {
        reviewTabElement.click();
      });
    });
  }
}
